<template>
  <div class="child-view">
    <h2 class="heading-1 u-margin-top">
      {{ $t('buyCredits.header') }}
    </h2>
    <div v-if="creditsDataStore" class="credits-slider-container">
      <CreditsSlider
        v-show="showSlider"
        @showSlider="showSlider = $event"
        @purchaseData="getPurchaseData"
      ></CreditsSlider>
      <PaymentForm
        v-if="!showSlider"
        :purchase-data="purchaseData"
        @showSlider="showSlider = $event"
        @makePurchase="purchaseCredits"
      ></PaymentForm>
    </div>
  </div>
</template>

<script>
import CreditsSlider from '../components/Account/CreditsSlider';
import PaymentForm from '../components/Account/PaymentForm';
import { mapState } from 'vuex';
import DateTime from 'luxon/src/datetime.js';
export default {
  name: 'AccountBuyCredits',
  components: {
    CreditsSlider,
    PaymentForm
  },
  data() {
    return {
      showSlider: true,
      purchaseData: null
    };
  },
  computed: {
    ...mapState({
      creditsDataStore: (state) => state.payments.creditsData,
      userData: (state) => state.profile.profileData
    })
  },
  async created() {
    await this.$store.dispatch('getCreditsAndCountryData');
  },
  methods: {
    getPurchaseData(value) {
      this.purchaseData = value;
    },
    async purchaseCredits(event) {
      let expirationDate;

      this.userData.role === 'expert'
        ? (expirationDate = null)
        : (expirationDate = DateTime.local()
            .plus({ year: 1 })
            .set({ hour: 23, minute: 59, second: 59, millisecond: 999 }));

      const purchaseData = {
        creditsData: {
          amount: event.totalCredits,
          expirationDate: expirationDate
        },
        notification: {
          type: 'success',
          message: `feedback.success.purchaseCredits`,
          show: true
        }
      };
      await this.$store.dispatch('purchaseCredits', purchaseData);
      this.$router.push({ name: 'account' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>
